// Loaded as the very first import of src/index.js, so these run before any app
// module evaluates. Babel transpiles modern *syntax* but does not add modern
// *built-ins*, so old Android WebView / Chrome < 76 threw
// "Promise.allSettled is not a function" on the dashboard.
//
// This covers the core-js baseline: Object.fromEntries, flatMap, flat,
// trimStart, Promise.finally and friends.
import 'react-app-polyfill/stable';

// What the import above CANNOT cover: babel-preset-react-app hardcodes
// `corejs: 3`, i.e. core-js 3.0 module data, and these two were only promoted to
// stable in later core-js releases (Promise.allSettled in 3.8, globalThis in
// 3.6). The useBuiltIns:'entry' transform drops any module it does not know,
// including a direct `import 'core-js/modules/es.promise.all-settled.js'` --
// verified against the build output, where core-js's implementation was absent.
// CRA gives no way to override that preset option, so hand-shim them.
if (typeof Promise.allSettled !== 'function') {
  Promise.allSettled = function allSettled(values) {
    return Promise.all(
      Array.prototype.map.call(values, (value) =>
        Promise.resolve(value).then(
          (v) => ({ status: 'fulfilled', value: v }),
          (reason) => ({ status: 'rejected', reason })
        )
      )
    );
  };
}

if (typeof globalThis === 'undefined') {
  window.globalThis = window;
}
